import React from 'react'
import { Dashboard } from '../../components/Dashboard';

export const DashboardContainer = () => <Dashboard />;
